var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "p",
    {
      staticClass: "company-monitoring nochangepls",
      attrs: { "data-ogrn": _vm.ogrn },
    },
    [
      _vm.hasMonitoring
        ? _c("span", { attrs: { "data-ogrn": _vm.ogrn } }, [
            _c("span", { staticStyle: { color: "#009900" } }, [
              _vm._v("★ Включён мониторинг"),
            ]),
            _vm._v(" "),
            _vm.getCategoryNameById
              ? _c(
                  "span",
                  {
                    style: _vm.categoryStyleColor(
                      _vm.monitoredCompany.category_id
                    ),
                  },
                  [_vm._v(" - " + _vm._s(_vm.getCategoryNameById) + ",")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "dashed", on: { click: _vm.removeMonitoring } },
              [_vm._v("выключить.")]
            ),
            _vm._v(" "),
            _vm.showChangeCategoryMenu
              ? _c(
                  "div",
                  { staticClass: "company-monitoring__change-category" },
                  [
                    _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "click-outside-element",
                            rawName: "v-click-outside-element",
                            value: _vm.closeChangeCategoryMenu,
                            expression: "closeChangeCategoryMenu",
                          },
                        ],
                      },
                      [
                        _c("li", [_vm._v("Изменить категорию")]),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.setCompanyCategory(1)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "far fa-eye" }),
                            _vm._v(" Без категории"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.setCompanyCategory(2)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-people-carry" }),
                            _vm._v(" Поставщик"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.setCompanyCategory(7)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-user-slash" }),
                            _vm._v(" Недобросовестный "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.setCompanyCategory(4)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-dolly-flatbed" }),
                            _vm._v(" Клиент"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.setCompanyCategory(3)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-ghost" }),
                            _vm._v(" Конкурент"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.setCompanyCategory(5)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-hand-holding-usd" }),
                            _vm._v(" Должник"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.setCompanyCategory(8)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-sitemap" }),
                            _vm._v(" Аффилирован"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.setCompanyCategory(6)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-crown" }),
                            _vm._v(" VIP"),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _c(
            "span",
            {
              staticClass: "dashed company-monitoring-set",
              on: { click: _vm.addMonitoring },
            },
            [
              _c("span", [_vm._v("☆")]),
              _vm._v(" "),
              _c("span", [_vm._v("Включить мониторинг")]),
            ]
          ),
      _vm._v(" "),
      _vm.monitoredCompanyCategories && _vm.monitoredCompanyCategories.length
        ? _c(
            "span",
            [
              _c("span", [_vm._v("|")]),
              _vm._v(" "),
              _vm._l(_vm.monitoredCompanyCategories, function (e, i) {
                return _c("span", { key: i }, [
                  _c("span", { style: _vm.categoryStyleColor(e.id) }, [
                    _vm._v(_vm._s(e.title)),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "в " +
                        _vm._s(e.groups.join(", ")) +
                        _vm._s(
                          i != _vm.monitoredCompanyCategories.length - 1
                            ? ";"
                            : "."
                        )
                    ),
                  ]),
                ])
              }),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }